import { Button, Grid } from '@mui/material'
import React, { Fragment } from 'react'
import { Size, useModal } from '../../hooks/useModal'
import { Filter } from '../../components/_WMS/FilterComponent'
import { postExportPreSaleSkuMasive } from './api'
import { useApi } from '../../hooks/useApi'
import { Loading } from '../../components/UI'
import { Status } from '../../hooks/useFetchState'
import { Modal } from '../../components/_EOS/Modal'
import { ConfirmActionInverted } from '../../components/ConfirmAction/ConfirmActionInverted'

interface PreSaleSkuButtonBarProps {
  onClickCreatePreSaleSku: (psize?: Size) => void
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  selectedFilters: Filter[]
}

export const PreSaleSkuButtonBar: React.FC<PreSaleSkuButtonBarProps> = ({
  onClickCreatePreSaleSku,
  handleSnackbar,
  handleCloseModal,
  selectedFilters
}) => {
  const { state: StateExport, callApi: callApiExport } = useApi()

  const handleExportPreSaleSkuMasive = () => {
    callApiExport(postExportPreSaleSkuMasive(selectedFilters))
      .then(() => {
        handleCloseModal()
        confirmModalState.closeModal()
        handleSnackbar(`Proceso agendado correctamente`, true)
      })
      .catch((error) => {
        handleSnackbar('Error agendando exportación: ' + error, false)
      })
  }

  const confirmModalState = useModal<{}>('')

  if (StateExport.status === Status.Loading) return <Loading />

  return (
    <Fragment>
      <Grid container justifyContent='center' spacing={5}>
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={() => confirmModalState.openModal('sm')}
          >
            Descargar Stock Venta en Verde
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={() => onClickCreatePreSaleSku('sm')}
          >
            Modificar Stock Venta en Verde
          </Button>
        </Grid>
      </Grid>
      <Modal
        onClose={confirmModalState.closeModal}
        open={confirmModalState.isOpen}
        title={confirmModalState.title}
        maxWidth={confirmModalState.size}
      >
        <ConfirmActionInverted
          handleSubmitAction={() => handleExportPreSaleSkuMasive()}
          handleCloseModal={confirmModalState.closeModal}
          confirmTitle={`¿Desea agendar la exportación, según los filtros seleccionados?`}
          confirmText='Confirmar'
          negateText='Cancelar'
        />
      </Modal>
    </Fragment>
  )
}
